var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EmbedMedia',{attrs:{"id":_vm.embedId,"source":_vm.sourceValue,"aspect-ratio":_vm.aspectRatio,"aspect-ratio-mobile":_vm.aspectRatioMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }